import { useState } from "react";
import ConexionSockets from "../../componentes/conexionSockets.js";
import VentanaFlotante from "../../componentes/ventanaFlotante.js";

function Pruebas() {
  const [windows, setWindows] = useState([]);

  const addWindow = () => {
    const color = `hsl(${Math.floor(Math.random() * 360)}, 70%, 80%)`;
    const newWindow = { id: Date.now(), color, z: 0 };
    setWindows((prev) =>
      [...prev, newWindow].map((w, i) => ({ ...w, z: i + 1000 }))
    );
  };

  const closeWindow = (id) => {
    setWindows((prev) => prev.filter((w) => w.id !== id));
  };

  const bringToFront = (id) => {
    setWindows((prev) => {
      const clicked = prev.find((w) => w.id === id);
      const others = prev.filter((w) => w.id !== id);
      const reordered = [...others, clicked];
      return reordered.map((w, i) => ({ ...w, z: i + 1000 }));
    });
  };

  return (
    <div style={{ padding: "20px",color:"white" }}>
      <button onClick={addWindow}>New Window</button>

      {windows.map((w) => (
        <VentanaFlotante
          key={w.id}
          id={w.id}
          color={w.color}
          z={w.z}
          onFocus={() => bringToFront(w.id)}
          onClose={() => closeWindow(w.id)}
        />
      ))}

      <ConexionSockets/>
    </div>
  );
}

export default Pruebas;
